import {
  firstNameLabel,
  middleNameLabel,
  lastNameLabel,
  optionalLabel,
  suffixLabel
} from '../strings/labels'
import { suffixes } from '../choices'

export const firstNameField = {
  type: 'text',
  label: firstNameLabel,
  name: 'first_name'
}

export const middleNameField = {
  type: 'text',
  label: middleNameLabel,
  name: 'middle_name',
  requirementLabel: optionalLabel
}

export const lastNameField = {
  type: 'text',
  label: lastNameLabel,
  name: 'last_name'
}

export const suffixField = {
  type: 'select',
  label: suffixLabel,
  name: 'suffix',
  choices: [
    {
      value: '',
      label: ''
    },
    ...suffixes()
  ],
  requirementLabel: optionalLabel
}
